export default function pushData(event = 'page_load', data = {}) {
    data.event = event;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(data);
}
